import { Card, CardBody, Col } from "reactstrap";
import { HorizontalEditableDividerTitle } from "../../../Constants/Constants";
import { HorizontalEditableDividerData, HorizontalEditableDividerSubTitle } from "../../../Data/UiKits/Divider";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const HorizontalEditableDivider = () => {
  return (
    <Col md="6">
      <Card>
        <CommonCardHeader title={HorizontalEditableDividerTitle} span={HorizontalEditableDividerSubTitle} />
        <CardBody className="main-divider horizontal-variation">
          {HorizontalEditableDividerData.map((item, index) => (
            <div className={`divider linear-line double-line double-line-${index+1}`} key={index}>
              {item.text}
            </div>
          ))}
        </CardBody>
      </Card>
    </Col>
  );
};

export default HorizontalEditableDivider;
